export const getMediaURL = (apiRoot: string, entityUUID: string, scope?: string) =>
  `${apiRoot}/media/v1/media?entityUUID=${entityUUID}&scope=${scope}`;
